import React from 'react';
import './ValueProp.css';

const ValueProp = () => {
  const features = [
    {
      title: 'Kundenberatung',
      description: 'Wir beraten dich ausführlich um auf deine Bedürfnisse eingehen zu können.',
    },
    {
      title: 'Messung und Planung',
      description: 'Damit auch alles perfekt passt kommen wir direkt zu dir nach Hause und messen alles professionell nach damit es später keine Überraschungen gibt.',
    },
    {
      title: 'Genehmigung',
      description: 'Unser Team navigiert für dich durch den Bürokratiejungel als das du nur noch Unterschreiben musst und wir übernehmen den Rest.',
    },
    {
      title: 'Ausführung',
      description: 'Nach Unterschrift bekommst du regelmäßig Updates zum Status deines Bauvorhabens bis du deine fertige Investition begutachten kannst.',
    },
    {
      title: 'Garantie',
      description: 'Natürlich stehen wir hinter unserer Arbeit und das nicht nur mit unserem Namen.',
    },
    {
      title: 'Support',
      description: 'Solltest du später weitere Fragen zu deiner bestehenden Anlage haben tun wir unser Bestes dich auch weiterhin zu unterstützen.',
    },
  ];

  return (
    <div className="container">
      <h1>Dein regionaler Fachbetrieb für Haustechnik und Solar</h1>
      <p className="subtitle">Wir übernehmen das Projekt von A bis Z für eine wahres rundum sorglos Paket</p>
      
      <div className="features">
        {features.map((feature, index) => (
          <div className="feature" key={index}>
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ValueProp;
